var ImageIcon = require("components/utility/icons/ImageIcon");
var Spinner = require("components/utility/Spinner");
var TextToSpeech = require("lib/interface/TextToSpeech");
var SpeechToText = require("lib/interface/SpeechToText");
var TextTypes = require("lib/academic/TextTypes");
var Formats = require("lib/academic/Formats");
var CurrentUser = require("lib/account/CurrentUser");
var NameLookup = require("lib/data/NameLookup");

require("writing/activities/activity.scss");
class Activity extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			nodeData: null, openBookPicker: true, bookSelectF: null, phase: null
		};
	}

	onBookSelect(bookData) {
		if (this.state.bookSelectF) {
			this.state.bookSelectF(bookData);
		}
	}

	nodeToReact(nodeData, index) {
		nodeData = _.clone(nodeData)
		if (nodeData == null) { throw "Empty node"; }
		if (nodeData.tag == undefined) {
			throw "No tag specified in: " + JSON.stringify(nodeData);
		}

		var nodeProps = _.clone(nodeData.attributes) || {};

		if (nodeProps["style"]) {
			var mappedStyle = {};
			_.each(nodeProps["style"], function(value, key) {
				// Thanks @rfw http://stackoverflow.com/a/6661012/4557470
				var newKey = key.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); })
				mappedStyle[newKey] = value;
			});
			nodeProps["style"] = mappedStyle;
		}

		function mapAttribute(fromAttr, toAttr) {
			if (nodeProps[fromAttr] != undefined) {
				nodeProps[toAttr] = nodeProps[fromAttr];
			}
			// It might have been undefined, so delete it anyway
			delete nodeProps[fromAttr];
		}

		mapAttribute("class", "className");
		mapAttribute("for", "htmlFor");

		delete nodeProps["noWrap"]

		var nodeAttr = nodeData.attributes || {};
		if (((nodeData.tag == "input") && nodeAttr.value) || ((nodeData.tag == "textarea") && nodeData.text)) {

			if (nodeData.tag == "input") {
				var defaultText = nodeAttr.value;
				delete nodeProps.value
			} else {
				var defaultText = nodeData.text;
				delete nodeData.text
			}

			if (!this.isCollaboration() || _.include(this.getRoleRefIDs(), nodeAttr.name)) {
				// In all cases except collaboration areas which don't belong to us
				nodeProps.defaultValue = defaultText
			} else {
				nodeProps.value = defaultText;
				nodeProps.readOnly = true;
			}
		}

		if (nodeData.text != undefined) {
			nodeProps.children = nodeData.text;

		} else if (nodeData.children && (nodeData.children.length > 0)) {

			var children = nodeData.children.map(function(childData, index) {
				return this.nodeToReact(childData, index);
			}.bind(this));

			nodeProps.children = children;
		}

		// These are the only supported html types
		//    There may be a cleaner way to do this but I don't know it
		switch(nodeData.tag) {
			case "a":
				return <a { ...nodeProps } />
			case "button":
				return <button { ...nodeProps } />
			case "br":
				return <br { ...nodeProps } />
			case "canvas":
				return <canvas { ...nodeProps } />
			case "div":
				return <div { ...nodeProps } />
			case "em":
				return <em { ...nodeProps } />
			case "header":
				return <header { ...nodeProps } />
			case "h1":
				return <h1 { ...nodeProps } />
			case "h2":
				return <h2 { ...nodeProps } />
			case "h3":
				return <h3 { ...nodeProps } />
			case "img":
				return <img { ...nodeProps } />
			case "input":
				return <input { ...nodeProps } />
			case "label":
				return <label { ...nodeProps } />
			case "li":
				return <li { ...nodeProps } />
			case "option":
				return <option { ...nodeProps } />
			case "p":
				return <p { ...nodeProps } />
			case "select":
				return <select { ...nodeProps } />
			case "span":
				return <span { ...nodeProps } />
			case "strong":
				return <strong { ...nodeProps } />
			case "textarea":
				return <textarea { ...nodeProps } />
			case "ul":
				return <ul { ...nodeProps } />
			default:
				throw "Unsupported activity tag: " + nodeData.tag;

		}

	}

	render() {
		var activityClassName = "activityBox";

		if (this.state.nodeData == null) {
			var activityContent = undefined;
		} else {

			if (this.props.book && this.props.book.title) {
				var bookText = (
					<h3 className="textTitle onQuestionSelect">
						{ this.props.book.title }
					</h3>
				);

				activityClassName += " bookTitlePostionHack";
			}

			var activityContent = (
				<div key={ this.state.phase }>
					{ this.nodeToReact(this.state.nodeData) }
				</div>
			);
		}

		return (
			<div ref="activityBox" className={ activityClassName }>
				<link href="https://fonts.googleapis.com/css?family=Didact+Gothic" rel="stylesheet" />
				{ bookText }
				{ activityContent }
			</div>
		)
	}

	isCollaboration() {
		return Formats.isCollaboration(this.props.activity.format.format_class);
	}

	isDraft() {
		return this.props.response && this.props.response.draft;
	}

	getRoleRefIDs() {
		var currentRole = this.getCollaborationRole();
		var rolePhases = _.where(this.props.activity.format.phase_list, { role: currentRole });

		return $wr.findAllValues(rolePhases, "ref_id");
	}

	getCollaborationRole() {
		if (this.isDraft() && this.props.response.input_data) {
			var userID = CurrentUser.get().id;
			var roleList = JSON.parse(this.props.response.input_data["__wr_role_map"]);

			return _.findKey(roleList, _.partial(_.isEqual, userID));
		}
	}

	initAlbusActivity() {
		var updateActivity = function(albusStateData) {
			var nodeData = Albus.Builder.build(this.props.activity, albusStateData);
			this.setState({ nodeData: nodeData, phase: albusStateData.currentPhase });
		}.bind(this);

		var stateData = {};
		if (this.isDraft()) {
			stateData["draft"] = this.props.response;
		}

		if (this.isCollaboration()) {
			stateData["currentRole"] = this.getCollaborationRole();
		}

		var nodeData = Albus.Builder.build(this.props.activity, stateData);

		this.setState({ nodeData: nodeData }, function() {
			Albus.Behavior.init(this.refs.activityBox, updateActivity, stateData);

		}.bind(this));
		$(this.refs.activityBox).on(Albus.Behavior.SUBMIT, function(e, responseData) {
			if (this.props.onSubmit) {
				this.props.onSubmit(responseData)
			}
		}.bind(this));
	}

	updateAlbusActivity(activity) {
		var albusStateData = {};

		if (this.isDraft()) {
			albusStateData.draft = this.props.response;
		} else {
			albusStateData.response = this.props.response;
		}

		if (this.isCollaboration()) {
			albusStateData["currentRole"] = this.getCollaborationRole();
			albusStateData["collaborativeActivityStudentMap"] = this.state.collaborativeActivityStudentMap;

			if (albusStateData.response) {
				albusStateData.response = _.extend({}, albusStateData.response,
					{ collaborativeActivityStudentMap: this.state.collaborativeActivityStudentMap })
			}
		}

		var nodeData = Albus.Builder.build(activity, albusStateData);
		this.setState({ nodeData: nodeData }, function() {
			var $lockedCanvases = $(this.refs.activityBox).find(".nonRolePhase").find(".albus-canvas");
			$lockedCanvases.trigger("albus-canvas-reload-draft");
		});
	}

	initAlbusResponse() {
		var stateData = { response: this.props.response };
		var nodeData = Albus.Builder.build(this.props.activity, stateData);
		this.setState({ nodeData: nodeData }, function() {
			Albus.Behavior.init(this.refs.activityBox)
		}.bind(this));
	}

	initAlbus() {
		if (this.isDraft() || this.props.response == null) {
			this.initAlbusActivity();
		} else {
			this.initAlbusResponse();
		}
	}

	// autoSaveActivity() {
	// 	var newData = $(this.refs.activityBox).find(".albus-activity").data("auto-save")();
	// 	if (this.checkIfModified(newData.input_data) && this.checkIfBookPresent()) {
	// 		//auto-save
	// 		var autoSavedData = _.clone(this.state.autoSavedData)
	// 		Object.keys(newData.input_data).forEach(function(key) {
	// 			autoSavedData[key] = newData.input_data[key]
	// 		})
	// 		newData.input_data = autoSavedData;

	// 		if (this.isCollaboration()) {
	// 			this.props.onAutoSave(newData, { update_ref_ids: this.getRoleRefIDs(), updateDraft: true });

	// 		} else {
	// 			this.props.onAutoSave(newData);
	// 		}

	// 		this.setState({ autoSavedData: autoSavedData, showAutoSaving: true });

	// 		setTimeout(function() {
	// 			this.setState({ showAutoSaving: false });
	// 		}.bind(this), 1000);

	// 	} else if (this.isCollaboration() && !$wr.isInactive(40)) {
	// 		this.props.updateDraft();
	// 	}
	// }


	// checkIfModified(input_data) {
	// 	var previous_input_data = this.state.autoSavedData

	// 	var refIDs = Object.keys(input_data);
	// 	if (this.isCollaboration()) {
	// 		refIDs = _.intersection(refIDs, this.getRoleRefIDs());
	// 	}

	// 	var modified = refIDs.some(function(ref_id) {
	// 	    var newValue = input_data[ref_id]
	// 	    var previousValue = previous_input_data[ref_id]
	// 	    if (newValue != previousValue) {
	// 	    	modified = true;
	// 	    	return true
	// 	    }
	// 	})
	// 	return modified
	// }

	getAutosaveData() {
		var $activity = $(this.refs.activityBox).find(".albus-activity");
		if ($activity.length == 0) {
			return { input_data: {}, activity_data: {} };
		} else {
			return $activity.data("auto-save")();
		}
	}

	getAutosaveHash() {
		var inputData = this.getAutosaveData().input_data;

		var refIDs = _.keys(inputData);
		if (this.isCollaboration()) {
			refIDs = _.intersection(refIDs, this.getRoleRefIDs());
		}

		var hashString = _.map(refIDs, function(refID) {
			return "refID: " + refID + "val: " + JSON.stringify(inputData[refID]);
		}.bind(this)).join(" - ");

		return $wr.hashCode(hashString);
	}


	initTextToSpeech() {
		var $wrap = $(this.refs.activityBox);
		var $labels = $wrap.find("label .innerLabel, .albus-instructions");
		$wrap.find(".pastPhase .textToSpeechButton").remove();

		$labels.each(function(i, el) {
			var $el = $(el);
			if ($el.closest(".albus-DragDropStructure").length > 0 || $el.data("t2s")) {
				return;
			}
			$el.data("t2s", true);

			var actionId = "t2s-text" + i;
			var imgSrc = require("misc/text-to-speech.png");
			var $img = $(`<img id='${ actionId }' class='textToSpeechButton' src='${ imgSrc }' />`);

			$el.append($img);

			var position = $el.position();
			var leftPos = position.left + $el.width() + 35;

			$el.addClass('textToSpeechContainer');

			// check to make sure it won't be placed too far right and get cut off
			if ($el.closest(".albus-absoluteBox").length > 0) {
				var baseElementLeft = $el.closest("label").position().left;
				var totalWidth = $el.closest(".albus-absoluteBox").width();
				var topPos = position.top;
				var maxLeft = totalWidth - baseElementLeft - 25;
			} else {
				var baseElementLeft = 0;
				var totalWidth = $el.closest(".textToSpeechContainer").width();
				var topPos = 0;
				var maxLeft = totalWidth - baseElementLeft;
			}
			if (leftPos > maxLeft) {
				leftPos = maxLeft;
			}

			$img.css("left", leftPos);
			$img.css("top", topPos);

			var voice = TextToSpeech.initVoice($el.text());
			$el.find(".textToSpeechButton").on('click',function() {
				if (speechSynthesis.speaking) {
					speechSynthesis.cancel();
				} else {
					speechSynthesis.speak(voice);
				}
			});
		})
	}
	initSpeechToText() {
		var $wrap = $(this.refs.activityBox);
		$wrap.find(".pastPhase .speechToTextButton").remove();

		$wrap.find('textarea, input[type=text]').each(function(i, el) {
			var $el = $(el);
			if ($el.data("t2s")) {
				return;
			}
			$el.data("t2s", true);

			var actionId = "s2t-textarea-" + i;
			$el.parent().addClass('textToSpeechContainer');

			var imgSrc = require("misc/speech-to-text.png");
			var $img = $(`<img id='${ actionId }' class='speechToTextButton' src='${ imgSrc }' />`);

			$el.after($img);

			var position = $el.position();
			var leftPos = position.left + $el.width() + 35;

			// check to make sure it won't be placed too far right and get cut off
			if ($el.closest(".albus-absoluteBox").length > 0) {
				var maxLeft = $el.closest(".albus-absoluteBox").width() - 20;
				if (leftPos > maxLeft) {
					leftPos = maxLeft;
				}
			}

			$img.css("left", leftPos);
			$img.css("top", position.top);

			$img.on('click',function() {
				SpeechToText.trigger(el, actionId);
			});
		});
	}
	disableScrollOnCanvas() {
		console.log("DISABLE SCROLL ON CANVAS")
		try {
			_.each($("canvas"), (canvas) => {
				console.log("DISABLING FOR ", canvas)
				canvas.addEventListener("touchstart",  function(event) {event.preventDefault()})
				canvas.addEventListener("touchmove",   function(event) {event.preventDefault()})
				canvas.addEventListener("touchend",    function(event) {event.preventDefault()})
				canvas.addEventListener("touchcancel", function(event) {event.preventDefault()})
			})
		} catch( error ) {
			console.log(error)
		}
	}

	componentDidMount() {
		var sources = [
			{"ref":"start_recording","path":"speech-to-text/start_recording","play":false},
			{"ref":"end_recording","path":"speech-to-text/end_recording","play":false}
		]
		window.wrL2eSound.addSource(sources,"speech_control")

		$wr.loadScript("/dependencies/albus.min.js", "Albus", () => {
			var checkDependencies = () => {
				if (Albus.Dependencies.Fabric && Albus.Dependencies.Recorder && !this.state.nodeData) {
					this.initAlbus();
				}
			}

			$wr.loadScript("/dependencies/fabric.min.js", "Fabric", () => {
				Albus.Dependencies.Fabric = window.fabric;
				checkDependencies();
			})

			$wr.loadScript("/dependencies/recorder.js", "Recorder", () => {
				Albus.Dependencies.Recorder = window.Recorder;
				checkDependencies();
			})

			// Just for review
			Albus.alternateBookPicker = function(callback) {
				var selectF = function(bookData) {
					this.refs.bookPickerModal.hide();
					callback(bookData);
				}.bind(this);

				this.setState({ bookSelectF: selectF });
				this.refs.bookPickerModal.show();
			}.bind(this);

			if ('webkitSpeechRecognition' in window) {
				SpeechToText.init()
			}

			if (this.isCollaboration()) {
				var roleMap = JSON.parse(this.props.response.input_data["__wr_role_map"]);

				NameLookup.translateMap(roleMap, function(studentHash) {
					this.setState({ collaborativeActivityStudentMap: studentHash }, function() {
						this.updateAlbusActivity(this.props.activity);
					}.bind(this));
				}.bind(this));
			}
		})
	}

	componentDidUpdate() {
		// Deal with modals not resizing
		// Hacky, hacky, HAAAACCCCCKYYYY
		for (var i = 0; i < 5; i++) {
			setTimeout(function() {
				$(window).trigger("resize");
			}, (i * 1000));
		}

		if ('webkitSpeechRecognition' in window) {
			setTimeout(function() {
				this.initTextToSpeech();
				this.initSpeechToText();
			}.bind(this), 1000);
		}
		this.disableScrollOnCanvas()
	}

	componentWillReceiveProps(nextProps) {
		window.wrL2eSound.removeSources('speech_control')
		if (this.isCollaboration() && (nextProps.response != this.props.response)) {
			this.updateAlbusActivity(nextProps.activity);
		}
	}
};

Activity.propTypes = StrictPropTypes({
	// Data on the activity. Details handled by Albus library
	activity: PropTypes.object.isRequired,

	// Data on the response (may be a draft). Details handled by Albus library
	response: PropTypes.object,

	// Book loaded dynamically (during activity completion only)
	book: PropTypes.object,

	// Function to call when the activity has been submitted
	onSubmit: PropTypes.func
});

module.exports = Activity;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/Activity.js